import React from 'react'
import "./index.css"
import { FaDownload, FaLinkedin } from "react-icons/fa";
import { saveAs } from 'file-saver'
import SampleResumePdf from "../Home/assets/balu-updated.pdf"
import { Button } from '@mui/material';
export const Footer = () => {
    const handleDownload = () => {
        saveAs(SampleResumePdf, 'BaluSurya-resume.pdf');
      };
      
  return (
    <div className='footer-bg'
    > 
    <div>
            <a href='http://www.linkedin.com/in/tekumudi-bala-suryanarayana-murthy-7224142b3'  rel="noreferrer" target='_blank' className='details'>
                <FaLinkedin/> LinkedIn
            </a>
        </div>
        <div>
            <p className='details'>Let's Build Something Together Feel Free To Reach<br/> Out If You'r Looking For a Frontend Developer.</p>
      <Button onClick={handleDownload} variant='contained' color='primary' style={{marginTop: '10px', fontSize: '8px', alignItems: 'center', height: '25px', textTransform: 'none'}}>
      <FaDownload className='icon-download'/> 
       Download Resume
      </Button>
    </div>
    <div>
        <h4 className='details'>Contact:</h4>
        <p className='details'>Balu Surya</p>
        <p className='details'>Email:- balusurya37@gmail.com</p>
        <p className='details'>Mobile:- 7989704916</p>
        <p className='details'>Hyderbad, Jubilee Hills</p>
        </div>
    </div>
  )
}
